<template>
  <div>
    <v-autocomplete
      :prepend-icon="icon ? icons.mdiAlphaCCircle : null"
      :clearable="clearable"
      hide-details="auto"
      :disabled="disabled"
      v-model="select"
      :items="lista"
      :label="label"
      item-value="id"
      item-text="nombre"
      :dense="outlined"
      :outlined="outlined"
      :loading="cargando"
      :rules="rules"
      @change="change"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title> No hay cuentas </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item }">
        <span> {{ item.nombre }} ({{ item.simbolo }}) </span>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title> {{ item.nombre }}( {{ item.simbolo }} )</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import { mdiAlphaCCircle, mdiPlusCircleOutline } from '@mdi/js'
import MaestroService from '@/api/servicios/MaestroService'
export default {
  components: {},
  props: {
    value: Object,
    jsonRespueta: Boolean,
    disabled: Boolean,
    dense: Boolean,
    outlined: Boolean,
    icon: Boolean,
    todos: Boolean,
    default: Number,
    clearable: Boolean,
    padres: {
      type: Object,
      default: {},
    },
    rules: Array,
    filtros:Object,
    label: {
      type: String,
      default: 'Moneda',
    },
  },

  setup(props, contex) {
    const lista = ref([])
    const select = ref(null)
    const cargando = ref(false)
    const dialog = ref(false)
    
    watch(props, () => {
      if (props.value != undefined) {
        select.value = props.value.id
      }else{
        select.value = null
      }
    })
    onBeforeMount(() => {
      cargarDatos()
      if (props.value != undefined) {
        select.value = props.value.id
      }
    })

    const GetActualizarLista = item => {
      lista.value.push(item)
      select.value = item.id
      dialog.value = false
    }
    const abrirModal = () => {
      dialog.value = true
    }
    const cargarDatos = () => {
      lista.value = []
      cargando.value = true
      try {
        MaestroService.listarMonedas({...props.filtros})
          .then(response => {
            console.log(response)
            if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
              lista.value = response.data.datos
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            cargando.value = false
          })
      } catch (error) {
        cargando.value = false
      }
    }

    watch(select, () => {
      const valor = lista.value.find(item => item.id == select.value)

      contex.emit('input', valor == undefined ? null : valor)
    })

    const change = () => {
      contex.emit('change')
    }

    return {
      icons: {
        mdiAlphaCCircle,
        mdiPlusCircleOutline,
      },
      lista,
      select,
      cargando,
      dialog,
      abrirModal,
      GetActualizarLista,
      cargarDatos,
      change,
    }
  },
}
</script>